import { clear } from "@testing-library/user-event/dist/clear";
import { useRef } from "react";
import ExpenseModel from "../Models/ExpensModel";
import FormeInput from "./FormeInput";



function FormeLayout(props){
  let titleRef = useRef();
  let dateRef = useRef();
  let priceRef = useRef();
  let DescriptionRef = useRef();

  let onSubmitHandler =(event) => {
    event.preventDefault();

    let newExpense = new ExpenseModel(
      titleRef.current.value,
      dateRef.current.value,
      priceRef.current.value,
      DescriptionRef.current.value
    );
         props.onNewExpense(newExpense);
         
    // let newExpense ={
    //   title: titleRef.current.value,
    //   date: dateRef.current.value,
    //   price : priceRef.current.value,
    //   Description :DescriptionRef.current.value
    //  };
    // alert(titleRef.current.value); 
    // //  alert(" submitted")
    clear();
  };
  // تستخدم لحزف البيانات من المربعات عند الضغط على زر اضافة 
  let clear=() => {
    titleRef.current.value=''
      dateRef.current.value=''
      priceRef.current.value=''
      DescriptionRef.current.value=''
  }
   return (
        <form className="row" onSubmit={onSubmitHandler}>

        {/* <div className="mb-3 col-md-6">
                <label className="htmlForm-label">Title</label>
                <input 
                type="type"
                className="Form-control addTitle "
                aria-describedby="" 
                ref={titleRef}
                
                /> 
          </div>  */}
  <FormeInput title = "title" type ="text" inputClass="addTitle" ref={titleRef} />
  <FormeInput title = "Date" type ="date" inputClass="addDate" ref={dateRef} />
  <FormeInput title = "Value" type ="number" inputClass="addValue" ref={priceRef}/>
  <FormeInput title = "Description" type ="text" inputClass="addDescrption" ref={DescriptionRef}/>

        
          
          <div className="mb-3 col-md-12 text-right">
            <button type="submit" className="btn btn-primary addBtn">Add</button>
          </div>
        </form>
    )
}
export default FormeLayout;